import jsPDF from 'jspdf'
import 'jspdf-autotable'
import moment from 'moment'
import { FRONT_BASE_URL } from 'src/config/Request'
import { wtGetDateMonthYearFormat } from 'src/helpers/commons/moment'
export const EmployeeBlankForm = () => {
  const doc = new jsPDF()

  const pageWidth = doc.internal.pageSize.width
  const logo = 'assets/wil-icon.png'
  const profilePicture = 'assets/profile_image4.png'

  doc.setTextColor('#3c4b64')
  doc.setFont('Helvetica', 'bold') //Header middle branch logo

  doc.addImage(logo, 'PNG', pageWidth - 200, 4, 25, 25)
  doc.line(pageWidth - 173, 7, pageWidth - 173, 27) // Adjust the coordinates as needed

  doc.setFontSize(11)
  doc.text('WAH', pageWidth - 171, 10, { align: 'left' })
  doc.setFontSize(11)
  doc.setFont('Helvetica')
  doc.text('INDUSTRIES', pageWidth - 171, 15)
  doc.text('LIMITED', pageWidth - 171, 20)
  doc.setFontSize(9)
  doc.text('www.wahindustries.com', pageWidth - 171, 25)

  let yPosition = 40



  const BasicDetailsTable = [
    [
      {
        content: 'PERSONAL DETAILS',
        colSpan: 5,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'First Name:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 23, halign: 'left', color: [4, 113, 222] },
        colSpan: 2,
      },
      { content: 'Last Name:', styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' } },
      {
        content:  '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      { content: 'Gender:', styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' } },
      {
        content: '',
        styles: { cellWidth: 23, halign: 'left' },
        colSpan: 2,
      },
      {
        content: 'Date of Birth:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Religion:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content:'',
        styles: { cellWidth: 23, halign: 'left' },
        colSpan: 2,
      },
      { content: 'Domicile:', styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' } },
      {
        content: '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'CNIC:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content:  '',
        styles: { cellWidth: 23, halign: 'left' },
        colSpan: 2,
      },
      {
        content: 'CNIC Issue Date:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 40, halign: 'left' },
      },
    ],
    [
      {
        content: 'CNIC Expiry Date:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content:'',
        styles: { cellWidth: 23, halign: 'left' },
        colSpan: 2,
      },
      {
        content: 'Blood Group:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Driving License:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content: 'Yes',
        styles: { cellWidth: 25, halign: 'center' },
      },
      {
        content: 'No',
        styles: { cellWidth: 25, halign: 'center' },
      },
      {
        content: 'License No:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content:  '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'License Issue Date:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 23, halign: 'left' },
        colSpan: 2,
      },
      {
        content: 'License Expiry Date:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content:'',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Passport:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content: 'Yes',
        styles: { cellWidth: 25, halign: 'center' },
      },
      {
        content: 'No',
        styles: { cellWidth: 25, halign: 'center' },
      },
      {
        content: 'Passport No:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content:  '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Passport Issue Date:',
        styles: { fontStyle: 'bold', cellWidth: 40, halign: 'left' },
      },
      {
        content:'',
        styles: { cellWidth: 23, halign: 'left' },
        colSpan: 2,
      },
      {
        content: 'Passport Expiry Date:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content:'',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
  ]
  const CompanyDetailsTable = [
    [
      {
        content: 'COMPANY DETAILS',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'Grade:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content:'',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Department Name:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content:'',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Designation:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Date of joining:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
  ]
  const FamilyParticularTable = [
    [
      {
        content: 'FAMILY PARTICULARS',
        colSpan: 5,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],

    [
      {
        content: 'Relationship',
        styles: { fontStyle: 'bold', halign: 'center' },
      },
      { content: 'Name', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'DOB', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'CNIC#', styles: { fontStyle: 'bold', halign: 'center' } },
      {
        content: 'Occupation',
        styles: { fontStyle: 'bold', halign: 'center' },
      },
    ],
  ]
  // const NextOfKinTable = [
  //   [
  //     {
  //       content: 'NEXT OF KIN',
  //       colSpan: 4,
  //       styles: { halign: 'center', fontStyle: 'bold' },
  //     },
  //   ],
  //   [
  //     {
  //       content: 'Full Name:',
  //       styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
  //     },
  //     {
  //       content: pdfData.next_of_kin ? pdfData.next_of_kin.name : '',
  //       styles: { cellWidth: 45, halign: 'left' },
  //     },
  //     {
  //       content: 'Relationship:',
  //       styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
  //     },
  //     {
  //       content: pdfData.next_of_kin ? pdfData.next_of_kin.relationship : '',
  //       styles: { cellWidth: 46, halign: 'left' },
  //     },
  //   ],
  //   [
  //     { content: 'CNIC:', styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' } },
  //     {
  //       content: pdfData.next_of_kin ? pdfData.next_of_kin.cnic : '',
  //       styles: { cellWidth: 45, halign: 'left' },
  //     },
  //     {
  //       content: 'Mobile no:',
  //       styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
  //     },
  //     {
  //       content: pdfData.next_of_kin ? pdfData.next_of_kin.mobile_no : '',
  //       styles: { cellWidth: 46, halign: 'left' },
  //     },
  //   ],
  //   [
  //     {
  //       content: 'Home Phone:',
  //       styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
  //     },
  //     {
  //       content: pdfData.next_of_kin ? pdfData.next_of_kin.home_phone : '',
  //       styles: { cellWidth: 45, halign: 'left' },
  //     },
  //     {
  //       content: 'Permanent Address:',
  //       styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
  //     },
  //     {
  //       content: pdfData.next_of_kin ? pdfData.next_of_kin.permanent_address : '',
  //       styles: { cellWidth: 46, halign: 'left' },
  //     },
  //   ],
  // ]
  const ContactDetailsTable = [
    [
      {
        content: 'CONTACT DETAILS',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'Mobile no:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Phone no:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Permanent Address:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Resident Address:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content:'',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Personal Email:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content:  '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Official Email:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content:  '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
  ]
  const OtherDetailsTable = [
    [
      {
        content: 'OTHER DETAILS',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'Marital Status:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Blood Group:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Religion:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content:'',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Education Status:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content:'',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Prior Experience:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content:'',
        colSpan: 3,
        styles: { cellWidth: 45, halign: 'left' },
      },
    ],
  ]
  const EmergencyDetailsTable = [
    [
      {
        content: 'EMERGENCY CONTACT DETAILS',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'Name:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Relationship with Employee:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content:'',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Phone no:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content:'',
        styles: { cellWidth: 45, halign: 'left' },
      },
      {
        content: 'Resident Address:',
        styles: { fontStyle: 'bold', cellWidth: 46, halign: 'left' },
      },
      {
        content: '',
        styles: { cellWidth: 46, halign: 'left' },
      },
    ],
    [
      {
        content: 'Email:',
        styles: { fontStyle: 'bold', cellWidth: 45, halign: 'left' },
      },
      {
        content: '',
        colSpan: 3,
        styles: { cellWidth: 45, halign: 'left' },
      },
    ],
  ]
  const EducationTable = [
    [
      {
        content: 'EDUCATION DETAILS',
        colSpan: 5,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'Name Of School/University',
        styles: { fontStyle: 'bold', halign: 'center' },
      },
      { content: 'Degree', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Major Specialization', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Completion Year', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Grade/CGPA', styles: { fontStyle: 'bold', halign: 'center' } },
    ],
  ]
  const WorkExperienceTable = [
    [
      {
        content: 'WORK EXPERIENCE',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      { content: 'Name of Employer', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Last job title', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Employement Period', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Salary', styles: { fontStyle: 'bold', halign: 'center' } },
    ],
  ]
  const QuestionTable = [
    [
      {
        content: `Are you currently Unemployed? ${''}`,
        styles: { halign: 'left', fontStyle: 'plain' },
      },
    ],
    [
      {
        content: `May we contact your previous employer(s)? ${''}`,
        styles: { halign: 'left' },
      },
    ],
  ]
  const ReferenceTable = [
    [
      {
        content: ' REFERENCES',
        colSpan: 6,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      { content: 'Name', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Organization', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Designation', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Relationship', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'E-mail Address', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Contact #', styles: { fontStyle: 'bold', halign: 'center' } },
    ],
  ]
  const QuestionTable2 = [
    [
      {
        content: `Are you under any service bond with your present employer? ${
          ''
        }`,
        styles: { halign: 'left', fontStyle: 'plain' },
      },
    ],
    [
      {
        content: `Are you a reservist in the armed forces? ${
           ''
        }`,
        styles: { halign: 'left' },
      },
    ],
    [
      {
        content: `Have you suffered from any illness disability during last 5 years? ${
          ''
        }`,
        styles: { halign: 'left' },
      },
    ],
    [
      {
        content: `Are you affiliated with any political party? ${
          ''
        }`,
        styles: { halign: 'left' },
      },
    ],
    [
      {
        content: `Have you ever been convicted for any criminal charge?  ${
         ''
        }`,
        styles: { halign: 'left' },
      },
    ],
  ]
  const BankDetailTable = [
    [
      {
        content: 'BANK ACCOUNT DETAILS',
        colSpan: 4,
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
    [
      {
        content: 'Bank Name',
        styles: { fontStyle: 'bold', cellWidth: 45, align: 'center' },
      },
      // {
      //   content: '',
      //   styles: { cellWidth: 45, halign: 'left' },
      // },
      {
        content: 'Branch',
        styles: { fontStyle: 'bold', cellWidth: 46, align: 'center' },
      },
      // {
      //   content: '',
      //   styles: { cellWidth: 46, halign: 'left' },
      // },
      // ],
      // [
      {
        content: 'Account Title',
        styles: { fontStyle: 'bold', cellWidth: 45, align: 'center' },
      },
      // {
      //   content: '',
      //   styles: { cellWidth: 45, halign: 'left' },
      // },
      {
        content: 'Account #',
        styles: { fontStyle: 'bold', cellWidth: 46, align: 'center' },
      },
      // {
      //   content: '',
      //   styles: { cellWidth: 46, halign: 'left' },
      // },
    ],
  ]
  const RelativesEmployedTable = [
    [
      {
        content: 'Do you have any relatives employed in POF or WIL? ',
        colSpan: 4,
        styles: { halign: 'left', fontStyle: 'bold' },
      },
    ],
    [
      { content: 'Name', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Department', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Designation', styles: { fontStyle: 'bold', halign: 'center' } },
      { content: 'Relationship', styles: { fontStyle: 'bold', halign: 'center' } },
    ],
  ]
  const AffirmTable = [
    [
      {
        content: 'I do solemnly affirm that:',
        styles: { halign: 'left', fontStyle: 'bold' },
      },
    ],
    [
      {
        content:
          'The information presented in this Form is accurate and truthful to the best of my knowledge and belief. I further confirm that all the details provided in this form are correct and complete to the best of my understanding.',
        styles: { halign: 'justify' },
      },
    ],
    // [
    //   {
    //     content:
    //       '2. I have joined WAH Industries Limited with no liabilities to any of my previous employer/s on date mentioned below.',
    //     styles: { halign: 'left' },
    //   },
    // ],
    [
      {
        content: '',
      },
    ],
    [
      {
        content: '',
      },
    ],
    [
      {
        content:
          'Employee Signature ___________________________   Date ___________________________',
        styles: { halign: 'center', fontStyle: 'bold' },
      },
    ],
  ]
  doc.autoTable({
    startY: yPosition,
    head: BasicDetailsTable.slice(0, 1), // Header rows for first table
    body: BasicDetailsTable.slice(1), // Body rows for first table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  const gapBetweenTable23 = 8
  const startYForTable3 = doc.autoTable.previous.finalY + gapBetweenTable23
  doc.autoTable({
    startY: startYForTable3,
    head: ContactDetailsTable.slice(0, 1), // Header rows for second table
    body: ContactDetailsTable.slice(1), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  const gapBetweenTables = 8
  const startYForTable2 = doc.autoTable.previous.finalY + gapBetweenTables
  doc.autoTable({
    startY: startYForTable2,
    head: CompanyDetailsTable.slice(0, 1), // Header rows for second table
    body: CompanyDetailsTable.slice(1), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  const gapBetweenfamilyTables = 8
  const startYForTable6 = doc.autoTable.previous.finalY + gapBetweenfamilyTables
  const FamilyParticularDetails = () => {
    let family_particular = []

  

      for (let i = 0; i < 3; i++) {
        family_particular.push([
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
        ])
      }
    

    family_particular.push([
      {
        content: 'Marital Status:',
        styles: { fontStyle: 'bold', halign: 'left' },
      },
      {
        content: '',
        colSpan: 4,
        styles: { halign: 'left' },
      },
    ])

    return family_particular
  }
  doc.autoTable({
    startY: startYForTable6,
    margin: { top: 20 },
    head: FamilyParticularTable, // Header rows for second table
    body: FamilyParticularDetails(), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    columnStyles: {
      0: { columnWidth: 30 },
      1: { columnWidth: 40 },
      3: { columnWidth: 50 },
    },
    didDrawPage: function (data) {},
  })
  // const gapBetweennextofkinTables = 8
  // const startYForTable7 = doc.autoTable.previous.finalY + gapBetweennextofkinTables
  // doc.autoTable({
  //   startY: startYForTable7,
  //   margin: { top: 20 },
  //   head: NextOfKinTable.slice(0, 1), // Header rows for second table
  //   body: NextOfKinTable.slice(1), // Body rows for second table
  //   theme: 'plain',
  //   tableLineColor: '#3c4b64',
  //   tableLineWidth: 0.2,
  //   tableWidth: 'auto', // Set table width automatically
  //   headStyles: { fillColor: [217, 218, 219] },
  //   styles: {
  //     lineColor: '#3c4b64',
  //     lineWidth: 0.2,
  //     halign: 'center',
  //     font: 'helvetica',
  //   },
  //   didDrawPage: function (data) {},
  // })
  // const gapBetweenTable34 = 12
  // const startYForTable4 = doc.autoTable.previous.finalY + gapBetweenTable34
  // doc.autoTable({
  //   startY: startYForTable4,
  //   margin: { top: 40 },
  //   head: OtherDetailsTable.slice(0, 1), // Header rows for second table
  //   body: OtherDetailsTable.slice(1), // Body rows for second table
  //   theme: 'plain',
  //   tableLineColor: '#3c4b64',
  //   tableLineWidth: 0.2,
  //   tableWidth: 'auto', // Set table width automatically
  //   headStyles: { fillColor: [217, 218, 219] },
  //   styles: {
  //     lineColor: '#3c4b64',
  //     lineWidth: 0.2,
  //     halign: 'center',
  //     font: 'helvetica',
  //   },
  //   didDrawPage: function (data) { },
  // })
  const gapBetweenTable45 = 6
  const startYForTable5 = doc.autoTable.previous.finalY + gapBetweenTable45
  console.log(startYForTable5)
  doc.autoTable({
    startY: startYForTable5,
    margin: { top: 20 },
    head: EmergencyDetailsTable.slice(0, 1), // Header rows for second table
    body: EmergencyDetailsTable.slice(1), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  const gapBetweenEducationTables = 6
  const startYForTable8 = doc.autoTable.previous.finalY + gapBetweenEducationTables
  const educationDetails = () => {
    let employee_education = []
 
      for (let i = 0; i < 7; i++) {
        employee_education.push([
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
        ])
      }
    

    return employee_education
  }
  doc.autoTable({
    startY: startYForTable8,
    margin: { top: 20 },
    head: EducationTable, // Header rows for second table
    body: educationDetails(), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  const gapBetweenWorkTables = 6
  const startYForTable9 = doc.autoTable.previous.finalY + gapBetweenWorkTables
  const EmployeeExperienceDetails = () => {
    let employee_experience = []
   
      for (let i = 0; i < 7; i++) {
        employee_experience.push([
          { content: '' },
          { content: '' },
          { content: '' },
          { content: '' },
        ])
      }
    

    return employee_experience
  }
  doc.autoTable({
    startY: startYForTable9,
    margin: { top: 20 },
    head: WorkExperienceTable, // Header rows for second table
    body: EmployeeExperienceDetails(), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  // const gapBetweenQuestionTables = 6
  // const startYForTable10 = doc.autoTable.previous.finalY + gapBetweenQuestionTables
  // doc.autoTable({
  //   startY: startYForTable10,
  //   margin: { top: 40 },
  //   body: QuestionTable,
  //   theme: 'plain',
  //   tableLineColor: '#3c4b64',
  //   tableLineWidth: 0.2,
  //   tableWidth: 'auto', // Set table width automatically
  //   styles: {
  //     lineColor: '#3c4b64',
  //     lineWidth: 0.2,
  //     halign: 'center',
  //     font: 'helvetica',
  //   },
  //   didDrawPage: function (data) { },
  // })
  // const gapBetweenBankTables = 8
  // const startYForTable11 = doc.autoTable.previous.finalY + gapBetweenBankTables
  // doc.autoTable({
  //   startY: startYForTable11,
  //   margin: { top: 40 },
  //   head: BankDetailTable.slice(0, 1), // Header rows for second table
  //   body: BankDetailTable.slice(1), // Body rows for second table
  //   theme: 'plain',
  //   tableLineColor: '#3c4b64',
  //   tableLineWidth: 0.2,
  //   tableWidth: 'auto', // Set table width automatically
  //   headStyles: { fillColor: [217, 218, 219] },
  //   styles: {
  //     lineColor: '#3c4b64',
  //     lineWidth: 0.2,
  //     halign: 'center',
  //     font: 'helvetica',
  //   },
  //   didDrawPage: function (data) { },
  // })
  // const gapBetweenReferenceTables = 8
  // const startYForTable12 = doc.autoTable.previous.finalY + gapBetweenReferenceTables
  // const ReferenceDetails = () => {
  //   let employee_references = []
  //   if (pdfData.employee_references.length) {
  //     pdfData.employee_references.map((item) =>
  //       employee_references.push([
  //         item.name,
  //         item.organization,
  //         item.designation,
  //         item.relationship,
  //         item.email,
  //         item.contact,
  //       ]),
  //     )
  //   } else {
  //     for (let i = 0; i < 3; i++) {
  //       employee_references.push([
  //         { content: '' },
  //         { content: '' },
  //         { content: '' },
  //         { content: '' },
  //         { content: '' },
  //         { content: '' },
  //       ])
  //     }
  //   }

  //   return employee_references
  // }
  // doc.autoTable({
  //   startY: startYForTable12,
  //   margin: { top: 40 },
  //   head: ReferenceTable, // Header rows for second table
  //   body: ReferenceDetails(), // Body rows for second table
  //   theme: 'plain',
  //   tableLineColor: '#3c4b64',
  //   tableLineWidth: 0.2,
  //   tableWidth: 'auto', // Set table width automatically
  //   headStyles: { fillColor: [217, 218, 219] },
  //   styles: {
  //     lineColor: '#3c4b64',
  //     lineWidth: 0.2,
  //     halign: 'center',
  //     font: 'helvetica',
  //   },
  //   didDrawPage: function (data) { },
  // })
  const gapBetweenRelativesEmployedTables = 8
  const startYForTable13 = doc.autoTable.previous.finalY + gapBetweenRelativesEmployedTables
  const RelativeDetails = () => {
    let employed_relative = []
    
      for (let i = 0; i < 2; i++) {
        employed_relative.push([{ content: '' }, { content: '' }, { content: '' }, { content: '' }])
      }
    

    return employed_relative
  }
  doc.autoTable({
    startY: startYForTable13,
    margin: { top: 20 },
    head: RelativesEmployedTable, // Header rows for second table
    body: RelativeDetails(), // Body rows for second table
    theme: 'plain',
    tableLineColor: '#3c4b64',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    headStyles: { fillColor: [217, 218, 219] },
    styles: {
      lineColor: '#3c4b64',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })

  const gapBetweenAffirmTables = 8
  const startYForTable15 = doc.autoTable.previous.finalY + gapBetweenAffirmTables
  doc.autoTable({
    startY: startYForTable15,
    margin: { top: 20 },
    body: AffirmTable, // Body rows for second table
    theme: 'plain',
    tableLineColor: '#ffffff',
    tableLineWidth: 0.2,
    tableWidth: 'auto', // Set table width automatically
    styles: {
      lineColor: '#ffffff',
      lineWidth: 0.2,
      halign: 'center',
      font: 'helvetica',
    },
    didDrawPage: function (data) {},
  })
  const addLogoToAllPages = () => {
    const pageCount = doc.internal.getNumberOfPages()
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i)
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold')

      const pageWidth = doc.internal.pageSize.width
      doc.setTextColor('#3c4b64')
      doc.setFont('Helvetica', 'bold') //Header middle branch logo

      doc.addImage(logo, 'PNG', pageWidth - 200, 4, 25, 25)
      doc.line(pageWidth - 173, 7, pageWidth - 173, 27) // Adjust the coordinates as needed

      doc.setFontSize(11)
      doc.text('WAH', pageWidth - 171, 10, { align: 'left' })
      doc.setFontSize(11)
      doc.setFont('Helvetica')
      doc.text('INDUSTRIES', pageWidth - 171, 15)
      doc.text('LIMITED', pageWidth - 171, 20)
      doc.setFontSize(9)
      doc.text('www.wahindustries.com', pageWidth - 171, 25)
    }
  }
  // addLogoToAllPages()

  // const addFooter = (doc) => {
  //   const pageCount = doc.internal.getNumberOfPages()
  //   let startPage = 1;
  //   for (let i = 1; i <= pageCount; i++) {
  //     doc.setPage(i)
  //     doc.setTextColor('black')
  //     doc.setFontSize(9)

  //     const lineHeight = 286 // Adjust this value as needed
  //     const lineWidth = 182 // Adjust this value as needed
  //     const lineX = 14 // Adjust this value as needed
  //     const lineY = lineHeight
  //     doc.line(lineX, lineY, lineX + lineWidth, lineY)
  //     // doc.text(`Page ${startPage} / ${pageCount}`, 190, 270, { align: 'right' })
  //     // startPage++;
  //     // if (startPage > 3) {
  //     //   startPage = 1
  //     // }
  //   }
  // }

  // addFooter(doc)

  doc.save('EmployeeForm.pdf')
}

